// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"F0-z","subtitle":"G0-z","wrapper":"H0-z","leftArrow":"I0-z","rightArrow":"J0-z"};